import DynamicRestApi from './dynamicRestApi'
import Cookie from 'js-cookie'

export default {
	getCookie () {
		const token = Cookie.get('XSRF-TOKEN')

		if (token) {
			return new Promise(resolve => {
				resolve(token)
				// Api.defaults.headers.common.Authorization = `Bearer ${token}`
			})
		}
		return DynamicRestApi.get('/sanctum/csrf-cookie')
	}
}
